module.exports = __webpack_public_path__ + "img/915c376a37609fbe9edf228324893d12.png";